import { useUpdateWorkspaceQuarantineSettings, useWorkspaceQuarantineSettings } from "@/api/workspace-safety";
import { QuarantineToggleRow } from "@/components/safety-config/QuarantineToggleRow";

/**
 * Quarantine defaults for the workspace. Same two toggles as the merchant
 * screen, but nothing is held or released here — a workspace owns no videos, so
 * these only decide the state a newly onboarded merchant starts in.
 */
export const WorkspaceQuarantineSection = ({ workspaceId }: { workspaceId: string }) => {
  const { data: settings, isLoading } = useWorkspaceQuarantineSettings(workspaceId);
  const update = useUpdateWorkspaceQuarantineSettings(workspaceId);

  if (isLoading) return null;

  return (
    <div className="flex flex-col gap-4">
      <div>
        <h2 className="text-base font-medium text-secondary">Quarantine</h2>
        <p className="text-sm text-quaternary mt-0.5">
          New merchants start with these settings. Changing them here doesn't affect merchants already onboarded.
        </p>
      </div>

      <div className="rounded-md border border-border-primary bg-white overflow-hidden">
        <QuarantineToggleRow
          label="Prevent videos with AI-detected risks from being ingested into GMV Max"
          description="Videos with any unresolved risk wait in Needs review until cleared."
          isSelected={settings?.quarantineUnreviewedVideos ?? false}
          isDisabled={update.isPending}
          onChange={(value) => update.mutate({ quarantineUnreviewedVideos: value })}
        />

        <QuarantineToggleRow
          label="Prevent videos Unbox cannot analyse from being ingested into GMV Max"
          description="Videos that fail analysis wait in Unable to analyse until reviewed."
          isSelected={settings?.quarantineUnanalysableVideos ?? false}
          isDisabled={update.isPending}
          onChange={(value) => update.mutate({ quarantineUnanalysableVideos: value })}
        />
      </div>
    </div>
  );
};
